export const PAYMENT_AGREEMENTS_LIST_KEY = 'PAYMENT_AGREEMENTS_LIST';
export const PAYMENT_AGREEMENTS_ONE_KEY = 'PAYMENT_AGREEMENTS_ONE_KEY';
export const PAYMENT_AGREEMENTS_VERIFY_KEY = 'PAYMENT_AGREEMENTS_VERIFY_KEY';
